export { formatNumber as default } from 'choerodon-ui/dataset';
